import { render, staticRenderFns } from "./unjudged.vue?vue&type=template&id=10d9a74e&scoped=true&"
import script from "./unjudged.vue?vue&type=script&lang=js&"
export * from "./unjudged.vue?vue&type=script&lang=js&"
import style0 from "./unjudged.vue?vue&type=style&index=0&id=10d9a74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9a74e",
  null
  
)

export default component.exports